/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ProductOrderMinimalPaginatedProperty =
  typeof ProductOrderMinimalPaginatedProperty[keyof typeof ProductOrderMinimalPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductOrderMinimalPaginatedProperty = {
  PRODUCT_NAME: 'PRODUCT_NAME',
  PLATFORM_NAME: 'PLATFORM_NAME',
  BANK_NAME: 'BANK_NAME',
  CUSTOMER_LAST_NAME: 'CUSTOMER_LAST_NAME',
  CUSTOMER_FIRST_NAME: 'CUSTOMER_FIRST_NAME',
  AMOUNT: 'AMOUNT',
  ORDER_TYPE: 'ORDER_TYPE',
  ORDER_STATUS: 'ORDER_STATUS',
  CREATED_AT: 'CREATED_AT',
  HAS_FAILURE: 'HAS_FAILURE',
} as const;
